import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onActivated, ref } from 'vue'
import { useRouter } from 'vue-router'
import { getErrorMessage } from '@/utils/error-handle'
import { requestCheckQualification } from '@/apis/agricultura-loan'
import { AgriculturalLoanApplyFormRouteName } from '@/defination/constant'
import { clearToast, showConfirmModal, showToastLoading } from '@/utils/tools'
import { useArgiculturaLoanKeepAliveControll } from '@/compositions/agricultura-loan/index'

import AppHeader from '@/components/Header.vue'
import LoanContractList from './components/loan-contract-list.vue'
import CommonFooterNextButton from '@/components/CommonFooterNextButton.vue'


import { defineComponent } from 'vue'
import { AgriculturalLoanContractListRouteName } from '@/defination/constant'
const __default__ = defineComponent({
  name: AgriculturalLoanContractListRouteName,
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const qualificationChecking = ref(false)
const $router = useRouter()

const { addContractListKeepAlive, removeContractListKeepAlive } =
  useArgiculturaLoanKeepAliveControll()
// 检验是否有贷款资质
async function checkQualification() {
  showToastLoading()
  try {
    const data = await requestCheckQualification()
    clearToast()

    if (data?.is_qualified) {
      applyLoanHandle()
    } else {
      showConfirmModal({
        title: '提示',
        message: data.message,
        confirmButtonText: '知道了',
        className: 'nongfu-dialog-confirm-class nongfu-dialog-message-center',
        showCancelButton: false,
      })
    }
  } catch (error) {
    const message = getErrorMessage(error)
    clearToast()
    showConfirmModal({
      title: '提示',
      message,
      confirmButtonText: '知道了',
      className: 'nongfu-dialog-confirm-class nongfu-dialog-message-center',
      showCancelButton: false,
    })
  }
}
// 申请贷款
function applyLoanHandle() {
  addContractListKeepAlive()
  $router.push({
    name: AgriculturalLoanApplyFormRouteName,
  })
}
// 检查贷款不通过提示
function checkFailHanlde() {}

onActivated(() => {
  removeContractListKeepAlive()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader, { title: "新农贷" }),
    _createVNode(LoanContractList),
    _createVNode(CommonFooterNextButton, {
      onClick: checkQualification,
      loading: qualificationChecking.value,
      title: "申请贷款"
    }, null, 8, ["loading"])
  ], 64))
}
}

})